<template>
  <div class="step-exibicao">
    <div class="section-label">Plataformas de exibição</div>
    <BooleanToggle
      v-for="canal in canais"
      :key="canal.campo"
      :label="canal.label"
      :help="canal.help"
      :value="Number(item[canal.campo]) === 1"
      @input="(valor) => $set(item, canal.campo, valor ? 1 : 0)"
    />
    <p v-if="semCanal" class="step-exibicao__aviso">
      <CIcon name="cil-warning" size="sm" class="mr-1" />
      Sem nenhuma plataforma marcada, o conteúdo fica cadastrado mas não aparece em lugar nenhum.
    </p>
  </div>
</template>

<script>
import BooleanToggle from "@/views/Campanhas/components/CampanhasComerciais/shared/BooleanToggle.vue";
import { CANAIS } from "../helpers/conteudoLabels";

const AJUDA_POR_CANAL = {
  acesso_site: "Portal web do cliente",
  acesso_app: "Aplicativo do cliente logado",
  acesso_cliente_final: "Aplicativo no modo de venda ao consumidor final",
};

export default {
  name: "StepExibicao",
  components: { BooleanToggle },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    canais() {
      return CANAIS.map((canal) => ({ ...canal, help: AJUDA_POR_CANAL[canal.campo] }));
    },
    semCanal() {
      return CANAIS.every((canal) => Number(this.item[canal.campo]) !== 1);
    },
  },
};
</script>

<style scoped>
.section-label {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-left: 3px solid #3a3e81;
  border-radius: 3px;
  background-color: #f2f4f7;
  font-size: 13px;
  font-weight: 700;
  color: #475467;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin: 0 0 14px;
}

.step-exibicao__aviso {
  display: flex;
  align-items: center;
  margin: 12px 0 0;
  padding: 8px 12px;
  border-radius: 6px;
  background: #fffaeb;
  color: #b54708;
  font-size: 12px;
}
</style>
